import { getSaleIdentifier } from "./saleRecord";
import type { SaleManagementResponse } from "../types/sale-management";

export function saleActivationLocation(sale: SaleManagementResponse) {
  return {
    pathname: `/sale-support/sales/${encodeURIComponent(getSaleIdentifier(sale))}/edit`,
    search: "?entry=activation",
    state: { activatedSale: sale },
  };
}

export function isActivatedSalePage(pathname: string, search: string): boolean {
  return /^\/sale-support\/(?:sales|tasks)\/[^/]+(?:\/edit)?\/?$/.test(pathname) &&
    new URLSearchParams(search).get("entry") === "activation";
}

export function legacySaleLocation(location: { pathname: string; search: string; hash: string; state?: unknown }) {
  const canonicalPath = (value: string) => value.replace(/^\/(?:sale-support|sell-support|app2)\/tasks(?=\/|$)/, "/sale-support/sales");
  let state = location.state;
  if (state && typeof state === "object" && !Array.isArray(state)) {
    const { activatedTask, taskListPath, taskIndex, ...rest } = state as Record<string, unknown>;
    state = {
      ...rest,
      ...(rest.activatedSale !== undefined || activatedTask !== undefined ? { activatedSale: rest.activatedSale ?? activatedTask } : {}),
      ...(rest.saleIndex !== undefined || taskIndex !== undefined ? { saleIndex: rest.saleIndex ?? taskIndex } : {}),
      ...(typeof (rest.saleListPath ?? taskListPath) === "string" ? { saleListPath: canonicalPath(String(rest.saleListPath ?? taskListPath)) } : {}),
    };
  }
  return { pathname: canonicalPath(location.pathname), search: location.search, hash: location.hash, state };
}
